import { useSelector } from "react-redux";

import { selectVatProfiles } from "../../app-main/selectors/fee-profile.selectors";
import { TAX_DETAILS_SCOPE } from "../TaxDetails/TaxDetails.consts";
import type { TaxDetailsScope } from "../TaxDetails/TaxDetails.types";
import { findProfileForSlot } from "../TaxDetails/TaxDetails.utils";
import { useTaxRegistrations } from "../TaxDetails/useTaxRegistrations";

/** The one registration this form is for. */
const useTaxDetailsFormRegistration = (scope: TaxDetailsScope) => {
  const isSubregion = TAX_DETAILS_SCOPE.subregion === scope;
  const { isLoading, registrations } = useTaxRegistrations();
  const vatProfiles = useSelector(selectVatProfiles);

  const registration = registrations.find(
    (candidate) => candidate.isSubregion === isSubregion,
  );

  // The registration carries what the banner needs; the profile behind it carries
  // the address, which is what the form opens with.
  const vatProfile = findProfileForSlot({ isSubregion, vatProfiles });

  return {
    isEdit: Boolean(registration?.id),
    isLoading,
    isSubregion,
    registration,
    registrationId: registration?.id ?? undefined,
    savedTaxTypes: registration?.taxTypes ?? [],
    vatProfile,
  };
};

export { useTaxDetailsFormRegistration };
